module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/university-of-idaho-f422165c7c0b11ab713753610842ab94.svg";